import React, { useState, useEffect, useRef } from "react";
import "../styles/Hero.css";

const characterSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const getRandomLetter = () =>
  characterSet[Math.floor(Math.random() * characterSet.length)];

function ScrambleText({ text, delay = 500, letterDelay = 200, scrambleInterval = 0 }) {
  const [displayText, setDisplayText] = useState(
    text.split("").map((letter) => (letter === " " ? " " : getRandomLetter()))
  );
  const resolvedRef = useRef(text.split("").map((letter) => (letter === " " ? true : false)));

  useEffect(() => {
    const timeouts = text.split("").map((_, index) =>
      setTimeout(() => {
        resolvedRef.current[index] = true;
        setDisplayText((prev) => {
          const newArr = [...prev];
          newArr[index] = text[index];
          return newArr;
        });
      }, delay + index * letterDelay)
    );
    return () => timeouts.forEach(clearTimeout);
  }, [text, delay, letterDelay]);

  useEffect(() => {
    if (scrambleInterval === 0) return;
    const interval = setInterval(() => {
      setDisplayText((prev) =>
        prev.map((letter, index) =>
          !resolvedRef.current[index] && text[index] !== " " ? getRandomLetter() : letter
        )
      );
    }, scrambleInterval);
    return () => clearInterval(interval);
  }, [text, scrambleInterval]);

  return <span className="scramble-text">{displayText.join("")}</span>;
}

const WORDS = [
  { english: "Secure", hindi: "सुरक्षित" },
  { english: "Reliable", hindi: "विश्वसनीय" },
  { english: "Innovative", hindi: "नवीन" },
];

const Hero = () => {
  const [hoveredWord, setHoveredWord] = useState(null);

  return (
    <header className="hero-section">
      {/* Video Background */}
      <video autoPlay loop muted playsInline className="hero-video">
        <source
          src="https://cdn.pixabay.com/video/2020/11/30/57904-486852810_large.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      {/* Content Overlay */}
      <div className="hero-content">
        <h1 className="hero-title">Welcome to</h1>
        <h1 className="hero-title scramble-text">
          <ScrambleText text="EncryptArx" delay={500} letterDelay={200} scrambleInterval={50} />
        </h1>
        <h3>Your Data's Impregnable Citadel!</h3>
        <p>
          {WORDS.map(({ english, hindi }, index) => (
            <span
              key={index}
              className="translate-word"
              onMouseEnter={() => setHoveredWord(english)}
              onMouseLeave={() => setHoveredWord(null)}
            >
              {hoveredWord === english ? hindi : english}
            </span>
          ))}
        </p>
        <a className="hero-link" href="/services">
          Explore Services
        </a>
      </div>
    </header>
  );
};

export default Hero;
